import { render, staticRenderFns } from "./NotesRoutineDialog.vue?vue&type=template&id=86c01b6e&scoped=true"
import script from "./NotesRoutineDialog.vue?vue&type=script&lang=js"
export * from "./NotesRoutineDialog.vue?vue&type=script&lang=js"
import style0 from "./NotesRoutineDialog.vue?vue&type=style&index=0&id=86c01b6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c01b6e",
  null
  
)

export default component.exports